import React, { useState, useEffect, useRef, Fragment } from "react";
import * as httpService from "../../services/httpService";
import { Employee_Api_EndPoints } from "../../global/end-points";
import * as userService from "../../utils/userService";
import { Link } from "react-router-dom";
import LoadingSpinner from "../common/loadingSpinner";
import { useTranslation } from "react-i18next";
import useActivityLogger from "../../utils/useActivityLogger";
import { useNavigate } from "react-router-dom"; // <-- import this

function Dashboard() {
  const { t } = useTranslation();
  const [isLoad, setIsLoad] = useState(false);
  const navigate = useNavigate(); // <-- initialize navigate
  const didMount = useRef(false);
  const [breadPoints, setBreadPoints] = useState({
    rafilTarget: 0,
    breadPointsPerTrans: 0,
    earnedPoints: 0,
    totalPay: 0,
  });
  const { totalPay } = breadPoints;

  // ✅ detect if OBO login
  const isOBO = !!sessionStorage.getItem("OnBehalfUserId");

  // ✅ use logger
  const { logClick } = useActivityLogger({ moduleCode: "DPY" });



  useEffect(() => {
    if (!didMount.current) {
      get_target_earned_points();
    }
    didMount.current = true;

    // ✅ intercept back button for OBO users
    const handleBack = (event) => {
      if (isOBO) {
        event.preventDefault();
        navigate("/logout", { replace: true }); // 🔹 go to Logout screen
      }
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  const get_target_earned_points = () => {
    // ✅ decide which user to use
    const userId = Number(
      sessionStorage.getItem("OnBehalfUserId") || sessionStorage.getItem("UserId")
    );
    const phoneNumber =
      sessionStorage.getItem("OnBehalfPhoneNumber") ||
      sessionStorage.getItem("phoneNumber") ||
      "";

    if (userId) {
      const body = {
        UserId: userId,
        PhoneNumber: phoneNumber, // <-- now included if API expects it
        LocationId: 1,
      };

      httpService.Get(Employee_Api_EndPoints.EARNED_POINTS, body).then((resp) => {
        if (resp.status === 200) {
          setBreadPoints({ ...resp.data });
        }
        setIsLoad(true);
      });
    } else {
      setIsLoad(false);
      userService.ClearSession();
    }
  };

  return (
    <Fragment>
      {isLoad && (
        <div className="dashboard-container">
          {/* summary cards row start */}
          <div className="dashboard-card-row">
            <div className="summary-card">
              <div className="summary-card-inner">
                <div className="summary-card-details">
                  <h2 className="card-heading">{t("summary")}</h2>
                  <h2 className="wages-heading">{t("availableWagestoAccess")}</h2>
                  {totalPay === 0 ? (
                    <div>
                      <span className="wage-amount disabled">
                        $ {totalPay.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </span>
                      <h3 className="wage-card-number">{t("NoEarnedWages")}</h3>
                    </div>
                  ) : (
                    <span className="wage-amount">
                      $ {totalPay.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  )}
                  <div className="card-holder-details-provider"></div>
                </div>
              </div>
            </div>

            {/* ✅ Instant Payout button with logging */}
            <div className="get-your-dough-card">
              <div className="dough-card-inner">
                <Link
                  to="/doughsummary"
                  className="get-your-dough-btn"
                  onClick={logClick(
                    isOBO ? "OBO.Btn.InstantPayout" : "Normal.Btn.InstantPayout",
                    isOBO
                      ? "OBO-Instant Payout Button Click"
                      : "Instant Payout Button Click"
                  )}
                >
                  {t("GetDh")}
                </Link>
              </div>
            </div>

          </div>
          {/* summary cards row end */}

          <div className="bread-points-section"></div>
        </div>
      )}
      {!isLoad && <LoadingSpinner />}
    </Fragment>
  );
}

export default Dashboard;
